import { render } from "./NextEditor.vue?vue&type=template&id=426fc612&ts=true"
import script from "./NextEditor.vue?vue&type=script&lang=ts"
export * from "./NextEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__